import React from "react";
import { AppearanceContextType, useAppearanceContext } from "@contexts/AppearanceContext";
import { UserContextType, useUserContext } from "@contexts/UserContext";

interface WidgetIconProps {
    name: string; // Name of widget, maps to enum in WidgetDataManager - WidgetName (TODO: move this enum elsewhere)
    icon: string; // SVG icon reference string for widget
    isOpen: boolean; // If the widget is open on the canvas
}

export default function WidgetToolbarIcon(props: WidgetIconProps) {
    const { icon, isOpen } = props;

    const { lightMode }: AppearanceContextType = useAppearanceContext();
    const { userData }: UserContextType = useUserContext();

    if (!icon) {
        return null;
    }

    let iconClass: string;
    if (isOpen) {
        iconClass = "active";
    } else if (!userData) {
        iconClass = "disabled";
    } else {
        iconClass = lightMode ? "light" : "dark";
    }

    return React.createElement(icon, { className: `toolbar-widget-icon ${iconClass}` });
}
